import type { BaseProps } from 'root/widgets/types';
import { MARKETPLACE } from 'root/widgets/constants';
import { Placement } from 'react-bootstrap/esm/types';

export enum BadgeVariant {
  LISTING = 'listing',
  AGENT = 'agent',
}

export const VERIFIED_BADGE_EVENTS = {
  VERIFIED_BADGE_CLICK: 'verified-badge:agent:verified-badge-click',
  REPORT_VERIFIED_AGENT: 'verified-badge:agent:report-verified-agent',
};

export interface ExplanationProps {
  title: string;
  description: string;
  subTitle?: string;
  details: Array<{
    title?: string;
    description?: string;
    iconName?: string;
  }>;
}

export enum PopoverVariant {
  DARK = 'dark',
  LIGHT = 'light',
}

export enum ActionableVariant {
  LINK = 'link',
  LIGHT = 'light',
  PRIMARY = 'primary',
}

export enum ActionableSize {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
}

export interface PopoverProps {
  title?: string;
  description: string;
  buttonLabel?: string;
  buttonUrl?: string;
  placement?: Placement;
  delay?: {
    show: number;
    hide: number;
  };
  show?: boolean;
  variant?: PopoverVariant;
}

export interface VerifiedBadgeProps extends BaseProps {
  text: string;
  icon: string;
  variant: BadgeVariant;
  marketplace?: MARKETPLACE;
  modalTitle: string;
  modalSize?: 'sm' | 'lg' | 'xl';
  note?: string;
  explanation: ExplanationProps;
  popover: PopoverProps;
  trackingData?: {
    segmentData?: {
      [key: string]: string | number | boolean;
    };
  };
}
